enum Permission {
  ACCESS_TO_ACCOUNT_MANAGEMENT = 1,
  ACCESS_TO_WORKSHOP_SETTINGS = 2,
  ACCESS_TO_POS_SETTINGS = 3,
  WRITE_IN_CHATS = 8,
  ACCESS_TO_BOOKINGS = 10,
  ACCESS_TO_DOSSIERS = 14,
  CAN_CHECKOUT = 24,
  WAREHOUSE = 25,
  FRONTDESK = 26,
  WORKSHOP_PLANNING_READ_ACCESS = 28,
  WORKSHOP_PLANNING_WRITE_ACCESS = 29,
  CAN_PERFORM_FINAL_CHECK = 31,
  ACCESS_TO_ALL_DOSSIERS = 34,
  WARRANTY_TEAM_MEMBER = 35,
  CAN_SUBMIT_SURVEY_FEEDBACK = 38,
  CAN_SEE_CSS_TASKS = 39,
  IS_MECHANIC = 40,
  ACCESS_TO_QUOTES = 43,
  CAN_ADD_SLA = 45,
  CAN_EDIT_REPAIR_ORDER = 47,
  ACCESS_TO_CONTACTS_DETAILS = 48,
  WORKSHOP_PLANNING_CLOSE_DAY = 49,
  CAN_SET_READY_FOR_PICKUP_AND_PICKED_UP = 50,
  MODIFY_TIME_REGISTRATIONS = 51,
  CAN_START_END_DAY_PLANNING = 54,
  CAN_EDIT_ALL_COMMENTS = 57,
  DRIVER = 59,
  KEEP_ASSIGNED_AT_CHECKOUT = 61,
  CAN_SHARE_DOSSIER_OVERVIEW = 62,
  CAN_APPROVE_EXECUTION = 63,
  CAN_ADD_JOB = 64,
  RESTRICTED = 66,
  CAN_MANAGE_DRIVE_BOOKINGS = 68,

  // permissions defined by frontend
  CAN_CHANGE_INVOICE_STATUS = 1001,
}

export default Permission;
